import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';

import type { Scene as SceneType } from '@/types/scene.types';
import { main, app, getJsonFromUrl } from '../test/app_clean';
import { fetchScenes } from '@/api/Scene';
import { RecordPreviewButton } from '@/components/RecordRender';

export const SceneRecorder = () => {
  // const { sceneIndex } = useParams<{ sceneIndex: string }>();
  const { slug } = useParams<{ slug: string }>();
  const containerRef = useRef<HTMLDivElement>(null);
  const initializedRef = useRef(false);

  const [scene, setScene] = useState<SceneType | undefined>(undefined);
  //   const [isLoading, setIsLoading] = useState(false);
  const [_isSceneClean, setIsSceneClean] = useState(false);

  useEffect(() => {
    // setIsLoading(true);
    fetchScenes()
      .then((allScenes) => {
        // setScene(new Scene());
        const featuredScene = allScenes.find((scene) => scene.slug === slug);
        console.log(`--------- ${featuredScene?.actionsJsonFile}`);
        setScene(featuredScene);

        const getParams: any = getJsonFromUrl(window.location.search);

        console.log(`--------------- getParams ${getParams} ${scene}`);
        console.log(getParams);
        let debugMode = false;

        if ('debug' in getParams && getParams.debug.toLowerCase() === 'true') {
          debugMode = true;
        }

        // Only initialize once
        if (initializedRef.current) {
          return;
        }

        // Ensure the container exists
        if (!containerRef.current) {
          return;
        }

        let canvas = document.getElementById('mujoco-canvas') as HTMLCanvasElement;
        if (!canvas) {
          canvas = document.createElement('canvas');
          canvas.id = 'mujoco-canvas';
          canvas.style.width = '100%';
          canvas.style.height = '100%';
          canvas.style.display = 'block';
          containerRef.current.appendChild(canvas);
        }

        // Initialize the app
        initializedRef.current = true;
        main(featuredScene?.actionsJsonFile, containerRef.current, true)
          .catch((error) => {
            console.error('Failed to initialize MuJoCo test:', error);
            initializedRef.current = false; // Allow retry on error
          })
          .then(() => {
            console.log('---------------- loaded');
            //   setIsLoading(false);
            setIsSceneClean(true);
            app.thirdPersonPanControlsEnable = debugMode;
            app.debugMode = debugMode;

            //   app.overlayCallback = setOverlays;
            //   app.reactPlayCallback = handleReplayClick;

            app.onResize();
          });
      })
      .catch((err: unknown) => {
        console.error('Failed to fetch scenes:', err);
      });

    // Cleanup on unmount
    return () => {
      // The app_clean.ts code handles cleanup through its dispose method
      // We'll let it handle its own cleanup
    };
  }, [slug]);

  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Box
        ref={containerRef}
        id="canvas-container"
        // sx={{
        //   width: '100%',
        //   height: '100%',
        //   position: 'relative',
        // }}
        sx={{
          flex: 1,
          position: 'relative',
          overflow: 'hidden',
        }}
      ></Box>
      <RecordPreviewButton />
    </Box>
  );
};
